import { noop } from "utils/General";
import DeleteConfirmation from "components/Global/CRM/Modals/DeleteConfirmation";
import { Div } from "components/Base";
import React from "react";

const ConfirmationModal = ({
  hideModal,
  firstLine,
  secondLine,
  onConfirm = noop,
  confirmLabel = ""
}) => (
  <DeleteConfirmation
    width={536}
    hideModal={hideModal}
    orangeButton={false}
    heading={null}
    confirmLabel={confirmLabel}
    hideHeader={true}
    message={
      <Div pb={3}>
        <Div color="black" fw={3} bb={1} pb={3} mb={2} fs={3} py={5} bc="gray3">
          {firstLine}
        </Div>

        {secondLine}
      </Div>
    }
    onConfirm={onConfirm}
  />
);

export default ConfirmationModal;
